import { useState, useCallback } from "react";

export const useLogoManagement = (initialLogoUrl: string = "") => {
  const [logoFile, setLogoFile] = useState<File | null>(null);
  const [logoPreview, setLogoPreview] = useState<string>(initialLogoUrl);
  const [initialLogo, setInitialLogo] = useState<string>(initialLogoUrl);

  const handleLogoChange = useCallback((file: File) => {
    setLogoFile(file);
    const reader = new FileReader();
    reader.onloadend = () => {
      setLogoPreview(reader.result as string);
    };
    reader.readAsDataURL(file);
  }, []);

  const handleDrop = useCallback((file: File) => {
    setLogoFile(file);
    const reader = new FileReader();
    reader.onloadend = () => {
      setLogoPreview(reader.result as string);
    };
    reader.readAsDataURL(file);
  }, []);

  const handleRemoveLogo = useCallback(() => {
    setLogoFile(null);
    setLogoPreview("");
  }, []);

  const updateLogoPreview = useCallback((url: string) => {
    setLogoPreview(url);
  }, []);

  const hasLogoChanged = useCallback(() => {
    // If there's a new file selected, there's a change
    if (logoFile !== null) {
      return true;
    }

    // Compare current preview with initial logo
    const currentPreview = logoPreview.trim();
    const initial = initialLogo.trim();

    return currentPreview !== initial;
  }, [logoFile, logoPreview, initialLogo]);

  const setInitialLogoUrl = useCallback((url: string) => {
    setInitialLogo(url);
  }, []);

  return {
    logoFile,
    logoPreview,
    handleLogoChange,
    handleDrop,
    handleRemoveLogo,
    updateLogoPreview,
    hasLogoChanged,
    setInitialLogoUrl,
  };
};
